import { Injectable } from "@angular/core";
import { AuthProvider } from "../auth/auth";
import { AppConfig } from "../../config/app.config";
import { Customer } from "../../models/customer";
import { DataProvider } from "../data/data";

@Injectable()
export class AccountProviderMock {

    constructor() {
    }

    async getAccount(): Promise<Customer> {
        var x = new Customer();
        x.first_name = 'First';
        x.last_name = 'last';
        return x;
    }

    async updateAccount(account: Customer): Promise<boolean> {
        return true;
    }
}


// WEBPACK FOOTER //
// ./src/providers/account/account-mock.ts